var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoutSmallIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77164 18.2692C9.77164 18.6726 9.42603 19 9.0002 19H4.88582C2.19193 19 0 16.9236 0 14.3718V4.62821C0 2.07636 2.19193 0 4.88582 0H9.0002C9.42603 0 9.77164 0.327385 9.77164 0.730769C9.77164 1.13415 9.42603 1.46154 9.0002 1.46154H4.88582C3.04258 1.46154 1.54289 2.88215 1.54289 4.62821V14.3718C1.54289 16.1178 3.04258 17.5385 4.88582 17.5385H9.0002C9.42603 17.5385 9.77164 17.8658 9.77164 18.2692ZM17.7741 8.98356L13.6597 5.08613C13.3583 4.80064 12.8698 4.80064 12.5684 5.08613C12.267 5.37161 12.267 5.83447 12.5684 6.11995L15.3662 8.77018H6.94301C6.51717 8.77018 6.17156 9.09757 6.17156 9.50095C6.17156 9.90434 6.51717 10.2317 6.94301 10.2317H15.3662L12.5684 12.8819C12.267 13.1674 12.267 13.6303 12.5684 13.9158C12.7186 14.058 12.916 14.1301 13.1135 14.1301C13.311 14.1301 13.5085 14.059 13.6587 13.9158L17.7731 10.0183C18.0755 9.73091 18.0755 9.26905 17.7741 8.98356Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoutSmallIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoutSmallIcon.48fdfaf3fd77665fc87fef4c972c1171.svg";